import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="container-lg p-5 d-flex flex-column align-items-center text-center">
      <h1 className="display-4 fw-bold mb-3">404!</h1>
      <h4 className="mb-3">A keresett oldal nem található.</h4>
      <p className="text-muted mb-4">Lehet, hogy a link hibás, vagy az oldal már nem létezik.</p>
      <button className="btn btn-primary" onClick={() => navigate("/")}>
        Vissza a főoldalra
      </button>
    </div>

  );
}

export default NotFound;
